module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('dropup', {
    attrs: {
      "button-text": _vm.$t('vue.deleteday.delete_day_or_week'),
      "show": _vm.showDropUp
    },
    on: {
      "open": _vm.dropUp,
      "close": function($event) {
        _vm.showDropUp = false
      }
    }
  }, [_c('template', {
    slot: "list"
  }, [_vm._l((_vm.weekDaysLocale), function(weekdayNum) {
    return _c('li', {
      key: weekdayNum,
      on: {
        "click": function($event) {
          return _vm.setIsConfirmDeletion(weekdayNum)
        }
      }
    }, [_vm._v("\n        " + _vm._s(_vm.formattedDate(weekdayNum)) + "\n      ")])
  }), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.setIsConfirmDeletion('week')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('vue.deleteday.whole_week')))])], 2)], 2), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "d-modal"
    }
  }, [(_vm.isConfirmDeletion) ? _c('ModalConfirmation', {
    attrs: {
      "showClose": false
    },
    on: {
      "close": _vm.closeIsConfirmDelete,
      "confirm": _vm.confirmDelete
    }
  }, [_c('h3', {
    attrs: {
      "slot": "item"
    },
    slot: "item"
  }, [_vm._v(_vm._s(_vm.theDeleteText))])]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6d563741!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DeleteDayOrWeek.vue
// module id = 1639
// module chunks = 1